module.exports = __webpack_public_path__ + "static/media/banner6.e3b48ecc.jpg";